import { createContext, useState } from "react";
import PropTypes from "prop-types";

const SKILL_PROVIDER_AUTH_STORAGE_KEY = "skill-provider-login-user";

const getStoredSkillProviderUser = () => {
  try {
    const storedUser = localStorage.getItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
    return null;
  }
};

const SkillProviderAuthContext = createContext();

export const SkillProviderAuthProvider = ({ children }) => {
  const [skillProviderUser, setSkillProviderUser] = useState(
    getStoredSkillProviderUser,
  );

  const loginSkillProvider = (token, userInfo, skillProvider, dashboard) => {
    const userData = {
      token,
      role: "SkillProvider",
      userInfo,
      skillProvider,
      dashboard,
    };

    localStorage.setItem(
      SKILL_PROVIDER_AUTH_STORAGE_KEY,
      JSON.stringify(userData),
    );
    setSkillProviderUser(userData);
  };

  const logoutSkillProvider = () => {
    localStorage.removeItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
    setSkillProviderUser(null);
  };

  const updateSkillProviderProfile = (profile) => {
    if (!profile || typeof profile !== "object") return;

    setSkillProviderUser((currentUser) => {
      if (!currentUser) return currentUser;

      const updatedUser = {
        ...currentUser,
        userInfo: {
          ...currentUser.userInfo,
          email: profile.email || currentUser.userInfo?.email,
          name: profile.full_name || profile.name || currentUser.userInfo?.name,
          contact_number:
            profile.phone_number ?? currentUser.userInfo?.contact_number,
        },
        skillProvider: {
          ...currentUser.skillProvider,
          ...profile,
        },
      };

      localStorage.setItem(
        SKILL_PROVIDER_AUTH_STORAGE_KEY,
        JSON.stringify(updatedUser),
      );
      return updatedUser;
    });
  };

  return (
    <SkillProviderAuthContext.Provider
      value={{
        skillProviderUser,
        loginSkillProvider,
        logoutSkillProvider,
        updateSkillProviderProfile,
      }}
    >
      {children}
    </SkillProviderAuthContext.Provider>
  );
};

SkillProviderAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SkillProviderAuthContext;
